import { api, isEndpointLockError } from '../core';
import { GDPR_DOCUMENT_TAG } from '../constants';

export interface CompleteReviewRequest {
  documentId: string;
}

const completeReviewApi = api.injectEndpoints({
  endpoints: (builder) => ({
    completeReview: builder.mutation<null, CompleteReviewRequest>({
      query: ({ documentId }: CompleteReviewRequest) => ({
        url: 'gdpr/complete-review',
        method: 'POST',
        body: { documentId },
      }),
      // A lock refusal changed nothing, and refetching the document would re-open the AI processing failed dialog
      invalidatesTags: (_result, error, { documentId }) =>
        isEndpointLockError(error)
          ? []
          : [
              { type: GDPR_DOCUMENT_TAG, id: documentId },
              { type: GDPR_DOCUMENT_TAG, id: 'LIST' },
            ],
    }),
  }),
});

export const { useCompleteReviewMutation } = completeReviewApi;
